import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
      // Pass the error directly to the catch block of the calling function
      return Promise.reject(error);
    }
);

export default api;